import { render } from "./CreateOrgModal.vue?vue&type=template&id=037fec8b"
import script from "./CreateOrgModal.vue?vue&type=script&lang=js"
export * from "./CreateOrgModal.vue?vue&type=script&lang=js"

import "./CreateOrgModal.vue?vue&type=style&index=0&id=037fec8b&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__